export default __webpack_public_path__ + "static/burring-0bcfeb85afe99569bcdf1b91cdcf3a4d.png";